/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_UpdatedInputs */

const en_app_updated = /** @type {(inputs: App_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App has been updated`)
};

const nl_app_updated = /** @type {(inputs: App_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App is bijgewerkt`)
};

/**
* | output |
* | --- |
* | "App has been updated" |
*
* @param {App_UpdatedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const app_updated = /** @type {((inputs?: App_UpdatedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_UpdatedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_app_updated(inputs)
	return en_app_updated(inputs)
});